<template>
<div class="task">
		<div class="top-image">
            <div class="image">
			    <img :src="session.background_url" v-if="session.background_url">
            </div>
		</div>
        <div class="name">
            <b v-if="userInfo.realname" class="name">{{userInfo.realname}}</b>
            <b v-else class="name">{{userInfo.nickname}}</b>
        </div>
        <div class="main" v-for="(value,key) in schedule" :key="key">
            <div class="line" style="background:#d2020d">{{key}}</div>
            <div class="schedule" v-for="(item,index) in value" :key="index">
                <h3>{{item.session_name}}</h3>
                <div class="detail">
                <div class="left">
                    <p v-if="item.detail_start_at">{{formatTime(item.detail_start_at)}}-{{formatTime(item.detail_end_at)}}</p>
                    <p v-else>{{formatTime(item.chapter_start_at)}}-{{formatTime(item.chapter_end_at)}}</p>
                </div>
                <div class="right">
                    <p><b>{{item.chapter_name}}--{{item.detail_name}}</b></p>
                    <p>{{item.title}}</p>
                    <p v-if="item.zoom_set">zoom会议号：{{item.zoom_set.url}}</p>
                    <span v-if="item.zoom_set">zoom登录密码：{{item.zoom_set.password}}</span>
                    
                </div>
                </div>
            </div>
            <div class="line"></div>
        </div>
</div>
</template>
<script>
	import {OuterTask} from '../../../config/interface.js'
	export default{
		data(){
			return{
                htmlTitle:'',
                session:{},
                schedule:{},
                meeting_id:this.$route.query.meeting_id?this.$route.query.meeting_id:this.$route.query.MT_id,
                loading:true,
                timeList:[], //时间列表 判断是否有重合
                userInfo:[]
                
			}
		},
        created(){
        },
		mounted(){
			// this.getImg();
            this.getMeetingSchedule();
		},
		methods:{
           //获取信息
			getMeetingSchedule(){
				const url=OuterTask;
				const method='POST'
				let params={
                    writer_id:this.$route.query.writer_id?this.$route.query.writer_id:this.$route.query.w_id,
                    meeting_id:this.$route.query.meeting_id?this.$route.query.meeting_id:this.$route.query.MT_id,
                    token:this.$route.query.token
                };
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						this.schedule=res.data['schedules'];
                        this.session=res.data.mission_set;
                        this.userInfo=res.data.writer;
					}
                    else{
                        common.toast( res && res.error_msg ? res.error_msg : "未知错误",1000,'fail',()=>{

                            })
                    }
				})
			},
            formatTime(str){
                if(str){
                    str=str.slice(11,16);
                }
                return str;
            },
           
		}
	}
</script>
<style lang="scss">
.all{
    background-size:contain ;
    
}
.top-image{
    width:100%;
}
.transfer-image{
        width:100%
    }
.book-detail{
    padding:0 10px;
    .header{
        height:70px;
        img{
           width:100%;
            
        }
    }
    .content{
        .title{
            text-align: center;
            color: white;
            font-size:14px;
        }
        .subtitle{
            margin: 20px 0;
            color: white;
            // display: flex;
            // height: 120px;
            // align-items: center;
            text-align: center;
            display: flex;
            justify-content: center;
            div{
                width: 30%;
            }
            img{
                width:60px;
                height: 60px;
                // background: black;
                border:none;

            }
            span{
                
                font-size:25px;
                height:60px;
                line-height: 60px;
                color: white;
                
            }
        }
        .text{
            padding:0 10px 10px 10px;
            p{
                color: white;
                font-size:12px;
                line-height: 26px;
                b{
                    font-size:14px;
                }
            }
        }
        table{
            text-align: center;
            border: 1px solid rgb(209, 196, 196);
            border-collapse: collapse;
            word-break:break-all;
            th{
                background: rgb(243, 217, 217);
                font-size:12px;
                color: brown;
                // width:16.67%;
                border: 1px solid rgb(209, 196, 196);
            }
            tr{
                font-size:12px;
                background: white;
                border: 1px solid rgb(209, 196, 196);
                td{
                    border: 1px solid rgb(209, 196, 196);
                }
            }
        }

    }
    .tip{
            padding: 10px 0;
            color:white;
            word-break:break-all;
            line-height: 20px;
        }
    .qrcode{
        color: white;
        font-size:12px;
        height: 150px;
        margin:10px 10px  0px 10px;
        .bottom-qrcode{
            float:right;
            width:90px;
            img{
            width:90px;
            height:90px;
            }
            p{
            text-align: center;
            }

        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/TaskBook/Outer.vue